export default (element) => {
  // Programmatically get the column width
  const item = element.querySelector('.masonry-item');
  if (item) {
    const { parentElement } = item;
    const parentWidth = parentElement.getBoundingClientRect().width;
    const itemWidth = item.getBoundingClientRect().width
      + parseFloat(getComputedStyle(item).marginLeft)
      + parseFloat(getComputedStyle(item).marginRight);
    const columnWidth = Math.round(1 / (itemWidth / parentWidth));

    // We need this line since JS nodes are dumb
    const arrayOfItems = Array.prototype.slice.call(
      element.querySelectorAll('.masonry-item'),
    );
    arrayOfItems.forEach((resultItem) => {
       
      resultItem.style.top = '';
    });
    const trackHeights = {};
    arrayOfItems.forEach((item) => {
      // Get index of item
      const thisIndex = arrayOfItems.indexOf(item);
      // Get column this and set width
      const thisColumn = thisIndex % columnWidth;
      if (typeof trackHeights[thisColumn] === 'undefined') {
        trackHeights[thisColumn] = 0;
      }
      trackHeights[thisColumn]
        += item.getBoundingClientRect().height
        + parseFloat(getComputedStyle(item).marginBottom);
      // If the item has an item above it, then move it to fill the gap
      if (thisIndex - columnWidth >= 0) {
        const getItemAbove = document.querySelector(
          `${'.masonry-item'}:nth-of-type(${thisIndex - columnWidth + 1})`,
        );
        const previousBottom = getItemAbove.getBoundingClientRect().bottom;
        const currentTop = item.getBoundingClientRect().top
          - parseFloat(getComputedStyle(item).marginBottom);
         
        item.style.top = `-${currentTop - previousBottom}px`;
      }
    });
    const maxNumber = Object.values(trackHeights).reduce(
       
      (acc, current) => (parseInt(current, 10) > acc ? current : acc),
      0,
    );
     
    element.style.height = `${maxNumber}px`;
  }
};
